module.exports = __webpack_public_path__ + "static/media/onboarding-3.ca1e8241.svg";